import { Card, Divider, Link, Row, Text, Spinner } from '@nextui-org/react';
import React, { useState, useEffect } from 'react';
import { fetchWithJson } from "../../../lib/api";
import { error } from "../../../lib/userAlerts";
import endpoint from "../../../config/endpoint.json";

const OtherStats = ({ clientId }) => {
    const [stats, setStats] = useState({
        messages: 0,
        detentions: 0,
        loading: true
    });

    useEffect(() => {
        if (clientId) {
            fetchAllData(clientId);
        }
    }, [clientId]);

    const fetchAllData = async (clientId) => {
        try {
            setStats(prev => ({ ...prev, loading: true }));
            await Promise.all([
                fetchNotificationData(clientId),
                fetchDetentionData(clientId)
            ]);
        } catch (err) {
            console.error(err);
            error('Unable to fetch stats data');
        } finally {
            setStats(prev => ({ ...prev, loading: false }));
        }
    };

    const fetchNotificationData = async (clientId) => {
        try {
            const res = await fetchWithJson(endpoint.statsMessages, {
                company_id: clientId,
            });

            if (res.status !== 200) {
                error('Unable to fetch message counts');
                return;
            }

            const data = await res.json();
            setStats(prev => ({
                ...prev,
                messages: data?.messages?.notificationCount || 0
            }));
        } catch (err) {
            console.error(err);
            error('Unable to fetch message counts');
        }
    };

    const fetchDetentionData = async (clientId) => {
        try {
            const res = await fetchWithJson(endpoint.statsDetentions, {
                company_id: clientId,
            });

            if (res.status !== 200) {
                error('Unable to fetch detention counts');
                return;
            }

            const data = await res.json();
            setStats(prev => ({
                ...prev,
                detentions: data?.detentions?.detentionCount || 0
            }));
        } catch (err) {
            console.error(err);
            error('Unable to fetch detention counts');
        }
    };

    const StatRow = ({ label, value, link }) => (
        <Row justify="space-between" align="center" className="py-2">
            <Text size={16} color="$gray600">{label}</Text>
            {link ? (
                <Link 
                    href={link}
                    css={{ 
                        color: '$primary',
                        '&:hover': { opacity: 0.8 }
                    }}
                >
                    <Text size={16} weight="semibold">{value}</Text>
                </Link>
            ) : (
                <Text size={16} weight="semibold" color="$gray900">{value}</Text>
            )}
        </Row>
    );

    return (
        <Card 
            css={{ 
                br: 0,
                minWidth: '300px',
                transition: 'all 0.2s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '$lg'
                }
            }}
            bordered 
            shadow={false}
        >
            <Card.Header className="px-6 py-4">
                <Text size={20} weight="semibold" color="$gray900">
                    Other Stats
                </Text>
            </Card.Header>
            
            <Divider />
            
            <Card.Body css={{ br: 0, px: '$6', py: '$4' }}>
                {stats.loading ? (
                    <div className="flex justify-center items-center py-4">
                        <Spinner size="sm" color="primary" />
                    </div>
                ) : (
                    <>
                        <StatRow 
                            label="Driver Reminders (Last 30 Days)" 
                            value={stats.messages.toLocaleString()} 
                        />
                        <StatRow 
                            label="Open Detentions" 
                            value={stats.detentions.toLocaleString()} 
                            link="/driver/detention-management"
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default OtherStats;